import React from 'react';
import moment from 'moment';
import { ApIcon, colors, ApButtonIcon } from '@alixpartners/ui-components';

import { STATE_COLORS, ICON_NAMES } from '../common';
import { TFileSection, TFileStatus } from '../../../types';

import {
  Container,
  FileName,
  Wrapper,
  IconWrapper,
  OwnerWrapper,
  ActionsWrapper,
} from './UploadedFilesListItem.styles';

interface IUploadedFilesListItem {
  name: string;
  uploadDate: string;
  userName: string;
  status: TFileStatus;
  malformed?: boolean;
  malformedCount?: number;
  section: TFileSection;
  onDownloadMalformedClick?: () => void;
  onDeleteClick?: () => void;
  showUserName?: boolean;
}

export const UploadedFilesListItem: React.FC<IUploadedFilesListItem> = ({
  name,
  status,
  uploadDate,
  userName,
  malformed,
  malformedCount,
  section,
  onDownloadMalformedClick,
  onDeleteClick,
  showUserName,
}) => {
  return (
    <Container isMalformed={malformed}>
      <IconWrapper>
        {malformed ? (
          <ApIcon iconColor={colors.amber600} iconName={'warning_amber'} />
        ) : (
          <ApIcon
            iconColor={STATE_COLORS[status]}
            iconName={ICON_NAMES[status]}
          />
        )}
      </IconWrapper>
      <FileName>
        {malformed ? `Malformed rows ${malformedCount}` : name}
      </FileName>
      {malformed && <Wrapper>Malformed</Wrapper>}

      {showUserName && <OwnerWrapper>{userName}</OwnerWrapper>}
      <Wrapper>{moment(uploadDate).format('MM/DD/YYYY')}</Wrapper>
      <ActionsWrapper>
        {malformed && onDownloadMalformedClick && (
          <ApButtonIcon
            iconName="download"
            small
            onClick={onDownloadMalformedClick}
          />
        )}
        {onDeleteClick && (
          <ApButtonIcon iconName="delete" small onClick={onDeleteClick} />
        )}
      </ActionsWrapper>
    </Container>
  );
};
